// Query helpers shared by the legacy lead-table thunk. The flat endpoint
// filters LeadTreatment rows, so lead-owned fields must use the `lead__` path.
export const buildHealthcareProviderFilter = ({ isFlatPath, isArchived, nhsProviderStatus }) => {
    if (isArchived) return '';

    const field = isFlatPath ? 'lead__healthcare_provider' : 'healthcare_provider';
    return nhsProviderStatus
        ? `&${field}=NHS`
        : `&${field}__in=PRIVATE,OTHER`;
};

// Some legacy query fragments deliberately include a leading ampersand. Keep
// that convention while ensuring the assembled URL never contains blank query
// parameters (for example `&&healthcare_provider__in=...`).
export const normalizeLeadTableQuery = (query) => query
    .replace(/\?&+/g, '?')
    .replace(/&{2,}/g, '&')
    .replace(/&+$/, '');
